import React from "react";
import { t } from "i18next";
import { PageHeaderV2 } from "components";
import { useHistory, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import C from "Constants";

const BlockedPage = () => {
  const history = useHistory();
  const params = useParams();
  const { DomainType } = useSelector((state) => state.AppReducer);
  const { brandInfo } = useSelector((state) => state?.brandStorageReducer);

  const handleRefresh = () => {
    const pathname = DomainType === C.CUSTOM_DOMAIN 
      ? "/" 
      : `/${brandInfo?.setting?.temporaryDomainName || window.location.pathname.split('/')[1]}/`;
    history.replace(pathname);
  };

  return (
    <div className="store-page store-page-popup">
      <PageHeaderV2 pageTitle="Access Blocked" />
      <div className="flex flex-col items-center justify-center min-h-screen p-4 text-center">
        <h1 className="text-2xl font-bold text-red-600 mb-4">
          {t("Access Blocked")}
        </h1>
        <p className="text-gray-700 mb-6">
          {t("Your access has been blocked. Please contact support for assistance.")}
        </p>
        <button
          onClick={handleRefresh}
          className="bg-brand-base-primary text-white px-6 py-3 rounded font-bold"
        >
          {t("Go to Home")}
        </button>
      </div>
    </div>
  );
};

export default BlockedPage;